module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', [_c('div', {
    staticClass: "bg-gradient-to-b from-secondary to-primary"
  }, [_c('header', {
    staticClass: "text-white pt-4 pb-12 px-4 flex items-center justify-between"
  }, [_c('h1', {
    staticClass: "text-2xl flex items-center gap-3"
  }, [_c('router-link', {
    staticClass: "inline-flex items-center justify-center h-10 w-10 rounded-lg bg-white/15 hover:bg-white/25 transition",
    attrs: {
      "to": {
        name: 'liste-bouteilles'
      }
    }
  }, [_c('i', {
    staticClass: "inline-block h-12 w-12 mask mask-arrow-left bg-white"
  })]), _vm._v(" "), _c('span', [_vm._v("Ajout bouteille")])], 1), _vm._v(" "), (_vm.urlAdmin !== undefined) ? _c('button', {
    staticClass: "bg-white text-primary text-sm font-medium px-4 py-2 rounded-lg shadow-sm hover:shadow transition",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.generatePopup()
      }
    }
  }, [_vm._v("\n                Infos bouteille\n            ")]) : _vm._e()])]), _vm._v(" "), _c('main', {
    staticClass: "bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 overflow-y-auto shadow-xl"
  }, [_c('div', {
    staticClass: "m-2 shadow-2xl rounded-lg overflow-hidden mb-24"
  }, [_c('div', {
    staticClass: "bg-white p-4"
  }, [_c('form', {
    staticClass: "space-y-4",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendForm($event)
      }
    }
  }, [_c('h2', {
    staticClass: "text-lg font-medium mb-5 uppercase text-secondary"
  }, [_vm._v("\n                        Informations de la bouteille\n                    ")]), _vm._v(" "), (_vm.$route.query.key1 && _vm.$route.query.key2 && _vm.bouteille) ? _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("\n                            OTAG "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    staticClass: "input",
    attrs: {
      "title": "otag",
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.$route.query.key1 + '-' + _vm.$route.query.key2
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("\n                            CODE BOUTEILLE\n                            "), _c('span', {
    staticClass: "text-alert ml-1"
  }, [_vm._v("(CODE BARRE CONSEILLÉ)")])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col sm:flex-row gap-2 items-start sm:items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.bouteille.code),
      expression: "bouteille.code",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "flex-1 input",
    attrs: {
      "id": "add_bottle_barcode",
      "title": "code",
      "placeholder": "Code bouteille",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.bouteille.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bouteille, "code", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "inline-flex items-center gap-2 bg-secondary text-white px-4 py-3 rounded-lg hover:opacity-95 transition",
    attrs: {
      "href": "fi360://scan?success=fillCodeBarre&type=bouteille",
      "id": "barcode-scan"
    }
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-scan-barcode bg-white"
  }), _vm._v("\n                                SCAN CODE BARRE\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-2 gap-4 mb-5"
  }, [_c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("TYPE DE BOUTEILLE "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bouteille.type),
      expression: "bouteille.type"
    }],
    staticClass: "input",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.bouteille, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeType]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Sélectionnez un type de bouteille")]), _vm._v(" "), _c('option', [_vm._v("Fluide frigorigène")]), _vm._v(" "), _c('option', [_vm._v("Récupération")]), _vm._v(" "), _c('option', [_vm._v("Transfert")])])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("DISTRIBUTEUR "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bouteille.fournisseur),
      expression: "bouteille.fournisseur"
    }],
    staticClass: "input",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.bouteille, "fournisseur", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Sélectionnez un fournisseur")]), _vm._v(" "), _vm._l((_vm.fournisseurs), function(fournisseur) {
    return _c('option', {
      key: fournisseur.id,
      domProps: {
        "value": fournisseur
      }
    }, [_vm._v("\n                                    " + _vm._s(fournisseur.nom) + "\n                                ")])
  })], 2)]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("NOM BOUTEILLE "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bouteille.nom),
      expression: "bouteille.nom"
    }],
    staticClass: "input",
    attrs: {
      "id": "nomBouteille"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.bouteille, "nom", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeNomBouteille]
    }
  }, _vm._l((_vm.noms_bouteille), function(n) {
    return _c('option', {
      key: n.id,
      staticClass: "opt-nombout",
      class: [n.volume_max !== null ? '' : 'nomax', n.id === 53 ? 'bouteilleID53' : ''],
      attrs: {
        "data-id": n.id
      },
      domProps: {
        "value": n
      }
    }, [_vm._v("\n                                    " + _vm._s(n.nom) + "\n                                ")])
  }), 0)]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("FLUIDE FRIGORIGÈNE "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bouteille.fluide),
      expression: "bouteille.fluide"
    }],
    ref: "selecfluide",
    staticClass: "input",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.bouteille, "fluide", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Sélectionnez un fluide frigorigène")]), _vm._v(" "), _c('option', {
    ref: "undefinedFluide",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": 0
    }
  }, [_vm._v("Indéfini")]), _vm._v(" "), _vm._l((_vm.fluides), function(fluide) {
    return (fluide.type !== 'CFC' && fluide.type !== 'HCFC' && fluide.nom !== 'R-999') ? _c('option', {
      key: fluide.id,
      domProps: {
        "value": fluide
      }
    }, [_vm._v("\n                                    " + _vm._s(fluide.nom) + _vm._s((fluide.nom_commercial) ? ' - ' + fluide.nom_commercial :
      '') + "\n                                ")]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("POIDS TOTAL DE FLUIDE "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), (_vm.recommandationPoids) ? _c('div', {
    staticStyle: {
      "margin-top": "-8px",
      "margin-bottom": "8px",
      "font-size": "0.85rem",
      "color": "#999",
      "font-style": "italic"
    }
  }, [_vm._v("\n                                Le distributeur préconise " + _vm._s(_vm.recommandationPoids.poidNet) + " kg,\n                                "), _c('a', {
    staticStyle: {
      "color": "#3490dc",
      "text-decoration": "underline",
      "cursor": "pointer",
      "font-style": "italic"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.appliquerRecommandationPoids($event)
      }
    }
  }, [_vm._v("Cliquez pour remplir cette valeur !")])]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.bouteille.poids_net),
      expression: "bouteille.poids_net",
      modifiers: {
        "number": true
      }
    }],
    ref: "poidsNet",
    staticClass: "input",
    attrs: {
      "title": "poidsNet",
      "type": "number",
      "step": "0.001",
      "inputmode": "decimal"
    },
    domProps: {
      "value": (_vm.bouteille.poids_net)
    },
    on: {
      "change": _vm.changePoidsNet,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bouteille, "poids_net", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.bouteille.poids_max),
      expression: "bouteille.poids_max",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.bouteille.poids_max)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bouteille, "poids_max", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("TARE")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.bouteille.tare),
      expression: "bouteille.tare",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    attrs: {
      "title": "tare",
      "type": "number",
      "step": "0.001",
      "inputmode": "decimal"
    },
    domProps: {
      "value": (_vm.bouteille.tare)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bouteille, "tare", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("RÉFÉRENCE LIVRAISON")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.bouteille.ref_livraison),
      expression: "bouteille.ref_livraison",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "title": "ref",
      "type": "text"
    },
    domProps: {
      "value": (_vm.bouteille.ref_livraison)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bouteille, "ref_livraison", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("DATE LIVRAISON "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bouteille.date_livraison),
      expression: "bouteille.date_livraison"
    }],
    staticClass: "input",
    attrs: {
      "title": "dateLivraison",
      "type": "date",
      "max": _vm.now
    },
    domProps: {
      "value": (_vm.bouteille.date_livraison)
    },
    on: {
      "change": function($event) {
        return _vm.calcRetour($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bouteille, "date_livraison", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("DATE DE RETOUR PRÉVU "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bouteille.date_retour_prevue),
      expression: "bouteille.date_retour_prevue"
    }],
    staticClass: "input",
    attrs: {
      "title": "dateRetour",
      "type": "date",
      "min": _vm.now
    },
    domProps: {
      "value": (_vm.bouteille.date_retour_prevue)
    },
    on: {
      "change": function($event) {
        return _vm.setDateRetour($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bouteille, "date_retour_prevue", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "w-full sm:w-auto bg-primary text-white font-semibold tracking-wide px-5 py-3 rounded-xl shadow hover:shadow-md active:scale-[0.99] transition",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                        AJOUTER\n                    ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-650bbd50","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bouteille/NewBouteille.vue
// module id = 1038
// module chunks = 0